export default "__VITE_ASSET__DRaPdCzN__"